import type { Settings } from '@services/user_settings.service';
import { storage } from '@visiba/std';

export const applicationLocalStorage = storage<{
	USER_SETTINGS: Settings;
}>({ type: 'local' });
